import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Goalboard } from './goalboard.entity'

export class GoalboardsRepository extends BaseRepository<Goalboard> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/goalboards', token, cache)
    }
}
